import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import Image from 'components/common/Image';
import Colors from 'constants/colors';
import FontStyles from 'constants/font-styles';

import icPinSampleHoshinoyaPC1x from 'assets/images/PC/@1x/ic_pin_sample_hoshinoya.png';
import icPinSampleHoshinoyaPC2x from 'assets/images/PC/@2x/ic_pin_sample_hoshinoya@2x.png';
import icPinSampleHoshinoyaSP2x from 'assets/images/SP/@2x/ic_pin_hoshinoya_sample@2x.png';
import icPinSampleHoshinoyaSP3x from 'assets/images/SP/@3x/ic_pin_hoshinoya_sample@3x.png';
import icPinSampleKaiPC1x from 'assets/images/PC/@1x/ic_pin_sample_kai.png';
import icPinSampleKaiPC2x from 'assets/images/PC/@2x/ic_pin_sample_kai@2x.png';
import icPinSampleKaiSP2x from 'assets/images/SP/@2x/ic_pin_kai_sample@2x.png';
import icPinSampleKaiSP3x from 'assets/images/SP/@3x/ic_pin_kai_sample@3x.png';
import icPinSampleRisonarePC1x from 'assets/images/PC/@1x/ic_pin_sample_risonare.png';
import icPinSampleRisonarePC2x from 'assets/images/PC/@2x/ic_pin_sample_risonare@2x.png';
import icPinSampleRisonareSP2x from 'assets/images/SP/@2x/ic_pin_risonare_sample@2x.png';
import icPinSampleRisonareSP3x from 'assets/images/SP/@3x/ic_pin_risonare_sample@3x.png';
import icPinSampleOmoPC1x from 'assets/images/PC/@1x/ic_pin_sample_omo.png';
import icPinSampleOmoPC2x from 'assets/images/PC/@2x/ic_pin_sample_omo@2x.png';
import icPinSampleOmoSP2x from 'assets/images/SP/@2x/ic_pin_omo_sample@2x.png';
import icPinSampleOmoSP3x from 'assets/images/SP/@3x/ic_pin_omo_sample@3x.png';
import icPinSampleBebPC1x from 'assets/images/PC/@1x/ic_pin_sample_beb.png';
import icPinSampleBebPC2x from 'assets/images/PC/@2x/ic_pin_sample_beb@2x.png';
import icPinSampleBebSP2x from 'assets/images/SP/@2x/ic_pin_beb_sample@2x.png';
import icPinSampleBebSP3x from 'assets/images/SP/@3x/ic_pin_beb_sample@3x.png';
import icPinSampleOtherPC1x from 'assets/images/PC/@1x/ic_pin_sample_other.png';
import icPinSampleOtherPC2x from 'assets/images/PC/@2x/ic_pin_sample_other@2x.png';
import icPinSampleOtherSP2x from 'assets/images/SP/@2x/ic_pin_other_sample@2x.png';
import icPinSampleOtherSP3x from 'assets/images/SP/@3x/ic_pin_other_sample@3x.png';

const brands = [
  {
    key: 'hoshinoya',
    images: {
      pc1x: icPinSampleHoshinoyaPC1x,
      pc2x: icPinSampleHoshinoyaPC2x,
      sp2x: icPinSampleHoshinoyaSP2x,
      sp3x: icPinSampleHoshinoyaSP3x,
      alt: 'ic_pin_sample_hoshinoya'
    },
    label: '星のや'
  },
  {
    key: 'kai',
    images: {
      pc1x: icPinSampleKaiPC1x,
      pc2x: icPinSampleKaiPC2x,
      sp2x: icPinSampleKaiSP2x,
      sp3x: icPinSampleKaiSP3x,
      alt: 'ic_pin_sample_kai'
    },
    label: '界'
  },
  {
    key: 'risonare',
    images: {
      pc1x: icPinSampleRisonarePC1x,
      pc2x: icPinSampleRisonarePC2x,
      sp2x: icPinSampleRisonareSP2x,
      sp3x: icPinSampleRisonareSP3x,
      alt: 'ic_pin_sample_risonare'
    },
    label: 'リゾナーレ'
  },
  {
    key: 'omo',
    images: {
      pc1x: icPinSampleOmoPC1x,
      pc2x: icPinSampleOmoPC2x,
      sp2x: icPinSampleOmoSP2x,
      sp3x: icPinSampleOmoSP3x,
      alt: 'ic_pin_sample_omo'
    },
    label: 'OMO'
  },
  {
    key: 'beb',
    images: {
      pc1x: icPinSampleBebPC1x,
      pc2x: icPinSampleBebPC2x,
      sp2x: icPinSampleBebSP2x,
      sp3x: icPinSampleBebSP3x,
      alt: 'ic_pin_sample_beb'
    },
    label: 'BEB'
  },
  {
    key: 'other',
    images: {
      pc1x: icPinSampleOtherPC1x,
      pc2x: icPinSampleOtherPC2x,
      sp2x: icPinSampleOtherSP2x,
      sp3x: icPinSampleOtherSP3x,
      alt: 'ic_pin_sample_other'
    },
    label: 'そのほかの<br />個性的な宿泊施設'
  }
];

const MapLegend = ({ className }) => (
  <div className={className}>
    <ul>
      {brands.map(({ key, images, label }) => (
        <li key={key} className={key}>
          <Image {...images} />
          <span className="legend-brand-name" dangerouslySetInnerHTML={{ __html: label}} />
        </li>
      ))}
    </ul>
  </div>
);

const commonStyle = css`
  background-color: ${Colors.gray4};
  border-radius: 8px;

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  span {
    color: ${Colors.brack1};
    text-align: left;
    line-height: 18px !important;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  width: 202px;
  height: 320px;
  padding: 16px;

  li {
    display: flex;
    align-items: center;
  }

  span {
    ${FontStyles.text10};
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  min-height: 76px;
  display: flex;
  justify-content: center;
  align-items: center;

  ul {
    max-width: 320px;
    height: 130px;
    margin: 0 -12px -4px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
  }

  li {
    height: 28px;
    margin: 0 12px 4px 0;
    display: flex;
    align-items: center;

    &.omo {
      span {
        width: 42px;
      }
    }
  }

  span {
    ${FontStyles.text8};

    br {
      display: none;
    }
  }
`;

export default applyStyles(MapLegend)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/Home/components/MapLegend.js